/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import Styles from '../../css/LoanDefaultCodes.module.css';
import { isObjEmptyOrNull } from '../../common/UtilityFunctions';
import { Select, SelectChangeEvent } from '@mui/material';
import menuItems from './MenuItems';
import { useLDCContext } from '../../contexts/LoanDefaultCodesContext';

type dropdownProps = {
  label: string;
  options: Array<any>;
  value;
  name: string;
  func?: (e: SelectChangeEvent<any>) => void;
  disable?: boolean;
  renderMode?: 'row' | 'control';
};

const DropdownSelect = ({ value, name, func, disabled, options, useAbbreviation, addBlankOpt, handleLDCChange }) => (
  <Select
    variant='standard'
    value={value}
    onChange={(e) => {
      func === null ? handleLDCChange('edit', name, e.target.value) : func(e);
    }}
    disabled={disabled}
    className={disabled ? `${Styles.disabled} ${Styles.menuoption}` : `${Styles.menuoption}`}
    MenuProps={{
      classes: { paper: Styles.menuPaper },
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center',
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'center',
      },
    }}
    size='small'
  >
    {menuItems(options, useAbbreviation, addBlankOpt)}
  </Select>
);

const selectDropdown = (props: dropdownProps) => {
  const { label, options, value, name, func = null, disable = false, renderMode = 'row' } = props;
  const { LDCFunctions, LDCUIStatuses } = useLDCContext();
  const { handleLDCChange } = LDCFunctions;
  const { isEditable } = LDCUIStatuses;
  const useAbbreviation = name === 'DDSCode' || name === 'investorDDSCode';
  const addBlankOpt =
    name === 'defaultBankruptcyStatus' ||
    name === 'foreclosureMainStatus' ||
    name === 'deedInLieuStatus' ||
    name === 'fnmaCutoffActionCode';

  if (isObjEmptyOrNull(options)) return;
  const disabled = options.length === 0 || !isEditable || disable;

  if (renderMode === 'control')
    return (
      <span className={disabled ? Styles.disabled : ''}>
        <DropdownSelect value={value} name={name} func={func} disabled={disabled} options={options} useAbbreviation={useAbbreviation} addBlankOpt={addBlankOpt} handleLDCChange={handleLDCChange} />
      </span>
    );

  return (
    <tr>
      <th>{label + ':'}</th>
      <td className={disabled ? Styles.disabled : ''}>
        {' '}
        {
          <DropdownSelect value={value} name={name} func={func} disabled={disabled} options={options} useAbbreviation={useAbbreviation} addBlankOpt={addBlankOpt} handleLDCChange={handleLDCChange} />
        }
      </td>
    </tr>
  );
};

export default selectDropdown;
